export const positionReference = {
  qb: 'quarterback',
  db: 'defensive back',
  rb: 'running back',
  wr: 'wide receiver',
  te: 'tight end',
  dt: 'defensive tackle',
  pk: 'kicker',
  p: 'punter',
  pn: 'punter',
  de: 'defensive end',
  lb: 'linebacker',
  cb: 'corner back',
  g: 'guard',
  c: 'center',
  t: 'tackle',
  k: 'kicker',
  ol: 'offensive lineman',
  dl: 'defensive lineman',
  s: 'safety',
  df: 'defense',
  st: 'special teams',
  ls: 'long snapper',
  og: 'guard',
  fb: 'fullback',
  fs: 'free safety',
  ot: 'offensive tackle',
  nt: 'nose tackle'
};

const irregular = {
  ol: 'offensive linemen',
  dl: 'defensive linemen',
  s: 'safeties',
  df: 'defense',
  st: 'special teams',
  fs: 'free safeties',
};

const format = (
  position,
  { plural = false, uppercase = false, capitalize = false },
) => {
  const pos = position.toLowerCase();
  let ref = positionReference[pos];

  if (!ref) return `Missing Ref: ${pos}`;

  if (plural) {
    if (irregular[pos]) {
      ref = irregular[pos];
    } else {
      ref = `${ref}s`;
    }
  }
  if (capitalize) {
    ref = ref.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1),
    ).join(' ');
  }
  if (uppercase) ref = ref.toUpperCase();

  return ref;
};

export const positionToTitle = (position, options = {}) =>
  [...new Set(position.split(',').map(pos => format(pos, options)))].join(' + ');



// WEBPACK FOOTER //
// ./src/lib/lookups.js